<div
  [closeDelay]="200"
  [ngbPopover]="isInvalid ? invalidMessage : ''"
  [openDelay]="300"
  class="d-inline-block limitWidth"
  container="body"
  ngbDropdown
  popoverClass="invalidMessageBox"
  triggers="mouseenter:mouseleave"
>
  <button
    [disabled]="disabled"
    [class.btn-outline-danger]="isInvalid"
    [class.btn-outline-primary]="!isInvalid"
    [class.btn-lg]="largeButtons"
    [ngStyle]="{ width: fixedWidth ? fixedWidth + 'px' : '100%' }"
    class="btn dropdown overflow-hidden"
    ngbDropdownToggle
  >
    {{ numberLabels ? 1 + selectedIndex + ')' : '' }}
    {{
      selectedValue
        ? upperCaseLabel
          ? (selectedValue.label | underscoreToSpace | capitalize)
          : (selectedValue.label | underscoreToSpace | titlecase)
        : 'Button'
    }}
  </button>
  <div aria-labelledby="dropdownMenu" ngbDropdownMenu>
    @for (value of values; track $index; let index = $index) {
      <button
        ngbDropdownItem
        (click)="selectDropdown(value, index)"
        [class.btn-lg]="largeButtons"
        class="dropdown-item customFont"
      >
        {{ numberLabels ? 1 + index + ')' : '' }}
        {{
          upperCaseLabel
            ? (value.label | underscoreToSpace | capitalize)
            : (value.label | underscoreToSpace | titlecase)
        }}
      </button>
    }
  </div>
</div>
